import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=0b285f7b&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=0b285f7b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b285f7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b285f7b')) {
      api.createRecord('0b285f7b', component.options)
    } else {
      api.reload('0b285f7b', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=0b285f7b&scoped=true", function () {
      api.rerender('0b285f7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/sidebar/components/menu.vue"
export default component.exports